
const UPDATE_REGISTER_CHECKED = function (state, payload) {
  state.checked = payload;
};

const UPDATE_REGISTER_USER_TYPE = function (state, payload) {
  state.userType = payload;
};

const UPDATE_ACC_NAME = function (state, payload) {
  state.accName = payload;
};

const SET_COMPANY_LEGAL_INFO = function (state, payload) {
  state.companyLegalInfo = payload;
};

const UPDATE_IS_LEGAL = function (state, payload) {
  state.isLegal = payload;
};

const UPDATE_ASSIGNOR_MOBILE = function (state, payload) {
  state.assignorMobile = payload;
};
const UPDATE_MOBILE = function (state, payload) {
  state.mobile = payload;
};

const UPDATE_PERSON_MOBILE = function (state, payload) {
  state.personMobile = payload;
};

const RESET_REGISTER_THIRD_STEP = function (state) {
  state.companyLegalInfo = {};
  state.assignorMobile = '';
  state.isLegal = false;
};

const RESET_REGISTER_FIRST_STEP = function (state) {
  state.checked = false;
  state.userType = null;
};

export const mutations = {
  UPDATE_REGISTER_CHECKED,
  UPDATE_REGISTER_USER_TYPE,
  UPDATE_ACC_NAME,
  SET_COMPANY_LEGAL_INFO,
  UPDATE_IS_LEGAL,
  UPDATE_ASSIGNOR_MOBILE,
  UPDATE_PERSON_MOBILE,
  RESET_REGISTER_FIRST_STEP,
  RESET_REGISTER_THIRD_STEP,
  UPDATE_MOBILE
};
